import React, { useRef, useState, useMemo } from 'react';
import styled from 'styled-components';
import { connect, useDispatch } from 'react-redux';
import { modalQueue, api_login, reset_account_create } from '../redux/actions';
import { Button, TextField, Link } from '@material-ui/core';
import { Colors } from "../common/colors";
import CONSTANTS from '../common/constants';
import { get } from 'lodash';
import IMAGES from '../common/images';
import Loader from './Loader.component';
import { showErrorMessage } from "../common/functions";
import PigeItInput from './PigeItInput.component';


function PigeItForgotPasswordEnterEmailComponent(props) {

  const dispatch = useDispatch();
  const [email,setEmail]=useState('');
  const [inProgress, setInProgress] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState('Reseting password...');

  return (
    <PigeItForgotPasswordEnterEmailStyle className="oginl-container">
      <div className="background-container">
        <div className="content-container">
          <Button className="modal-close-button" onClick={close}>
            <IMAGES.close />
          </Button>
          <div className="header-text">Enter your email address</div>
          <PigeItInput type='email' className={'input'} disabled={inProgress} value={email} onChange={(e) => setEmail(e.target.value)} label='Enter email'/>
          <button className={'ok button'+(CONSTANTS.VALID_EMAIL_REGEX.test(String(email))?'':' disabled')} onClick={confirm}> {inProgress && <Loader imageOnly />}RESET PASSWORD</button>
        </div>
      </div>

    </PigeItForgotPasswordEnterEmailStyle >
  );

  function confirm() {
    if(inProgress){
      return;
    }
   if(CONSTANTS.VALID_EMAIL_REGEX.test(String(email))){
    let request = {
      username: email,
      callback:function(result){
        setInProgress(false);
        dispatch(modalQueue({ mode: 'delete' }));
        if(result.success){
          let modalConfig = {
            ...CONSTANTS.MODALS_CONFIG.MESSAGE,
            buttons: { ok: { visible: true, text: 'OK' }, cancel: { visible: false, text: 'CANCEL' } },
            message: 'Check your email to reset password'
          };
          dispatch(modalQueue({ mode: 'insert', modalConfig: modalConfig }));
        }else{
          showErrorMessage(result,dispatch);
        }
      }
    }
    setInProgress(true);
    dispatch(reset_account_create(request));
   }
  }


  function close() {
    if(inProgress){
      return;
    }
    dispatch(modalQueue({ mode: 'delete' }));
  }


}

const mapStateToProps = (state, ownProps) => {
  return {
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  };
};

const PigeItForgotPasswordEnterEmailStyle = styled.div`
  width: 100%;
  height: 100%;
  .input{
    margin: 0 94px;
  }
  .button{
    background: unset;
    border: none;
    cursor: pointer;
    display: block;
    margin: auto;
    outline: none;
    &.ok{
      width: 350px;
      height: 56px;
      text-align: center;
      color: ${Colors.white};
      background-color: ${Colors.orange};
      font-size: 18px;
      font-family: museo_sans700;
      border-radius: 3px;
    }
    &.disabled{
      background-color:${Colors.lightGray4};
      cursor: unset;
    }
    .icon{
      svg{
        width: 16px;
        height: 13px;
        margin-right: 15px;
        path{
          fill: ${Colors.white};
        }
      }
    }
    
    .text{
      display: inline-block;
    }
  }
  
  .background-container {
    height: 100%;
    width: 100%;
    background-color: #fff;
    margin: 0 auto;
    
  }
  .content-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 80%;
    padding-top: 5%;
  }
  .modal-close-button {
    position: absolute;
    top: 21px;
    right: 26px;
  }
  .header-text {
    max-width: 350px;
    font-size: 21px;
    text-align: center;
    margin: auto;
    word-wrap: break-word;
  }
  @media only screen and (max-width: 992px) { 
    .header-text {
      font-size: 25px;
    }
    .zip-input{
      min-width: 280px;
    }
    .button{
      &.find-location{
        width: 302px;
      }
    }
    .input{
      margin: 0 22px;
    }
  }
`;

const PigeItForgotPasswordEnterEmail = connect(
  mapStateToProps,
  mapDispatchToProps
)(PigeItForgotPasswordEnterEmailComponent);




export default PigeItForgotPasswordEnterEmail;
